import React from 'react';

import { useScreenConfig } from '../config/screens.context';
import './SocialWall.scss';
import SocialWallBlock from './blocks/SocialWallBlock';

function SocialWallScreen() {
  const socialWallConfig = useScreenConfig('socialWall');
  return <SocialWallBlock containerType="headerless" {...socialWallConfig} />;
}

export default SocialWallScreen;
